import Index from '@/pages/photogroup/Index'
import List from '@/pages/photogroup/List'
import Create from '@/pages/photogroup/Create'
import Modify from '@/pages/photogroup/Modify'

export default {
  path: 'group',
  component: Index,  
  children: [
    {
      path: 'index',
      component: List
    },
    {
      path: 'create',
      component: Create
    },
    {
      path: 'modify/:id',
      component: Modify
    }
  ]
}
